    /** Resolve a Vuetify CSS custom property to an rgba() string */
    export function resolveThemeColor(cssVar: string, alpha = 1): string {
        const raw = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
        return raw ? `rgba(${raw}, ${alpha})` : `rgba(0, 0, 0, ${alpha})`;
    }